import { render } from "./AtencionesPorEstado.vue?vue&type=template&id=34d29729&scoped=true"
import script from "./AtencionesPorEstado.vue?vue&type=script&lang=js"
export * from "./AtencionesPorEstado.vue?vue&type=script&lang=js"

import "./AtencionesPorEstado.vue?vue&type=style&index=0&id=34d29729&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d29729"]])

export default __exports__